"use client";

import { c as _c } from "react/compiler-runtime";
import { Box, Grid, useMediaQuery, useTheme } from "@mui/material";
import LoginForm from "./LoginForm";
import Carousel from "./components/Carousel";
const LoginPage = function LoginPage() {
  const $ = _c(10);
  const theme = useTheme();
  let t0;
  if ($[0] !== theme.breakpoints) {
    t0 = theme.breakpoints.down("md");
    $[0] = theme.breakpoints;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const isSmallScreen = useMediaQuery(t0);
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      minHeight: "100vh",
      minWidth: "100vw",
      display: "flex",
      flexDirection: "column"
    };
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      flex: 1
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Grid size={{
      xs: 12,
      md: 7
    }} sx={{
      bgcolor: "grey.100",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }}><LoginForm /></Grid>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = isSmallScreen ? "none" : "flex";
  let t5;
  if ($[5] !== t4) {
    t5 = {
      display: t4,
      alignItems: "center",
      justifyContent: "center"
    };
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Carousel />;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t5) {
    t7 = <Box sx={t1}><Grid container={true} sx={t2}>{t3}<Grid size={5} sx={t5}>{t6}</Grid></Grid></Box>;
    $[8] = t5;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  return t7;
};
export default LoginPage;